export default "__VITE_ASSET__c21f899a__"